module.exports = __webpack_public_path__ + "media/images/neutral_button-5c3649d034f5eb5b95a6ffe07128c2d2.svg";